import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.graph.line');
import { OnInit, OnChanges, OnDestroy, Input, SimpleChanges, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
    selector: 'wiz-component-graph-line',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.graph.line/view.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}`],
})
export class ComponentGraphLineComponent implements OnInit, OnChanges, OnDestroy {

    @Input() data: {
        labels: string[];
        datasets: any[];
    } | null = null;

    public isEmpty: boolean = true;

    private chart?: Chart;

    constructor(@Inject( ElementRef) private el: ElementRef,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) {}

    ngOnInit() {
    }

    ngOnDestroy() {
        this.chart?.destroy();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            if (!this.data || !this.data.labels || this.data.labels.length === 0) {
                this.isEmpty = true;
                if (this.chart) {
                    this.chart.destroy();
                    this.chart = undefined;
                }
                return;
            }
            this.isEmpty = false;
            this.cdr.detectChanges();
            setTimeout(() => this.renderChart());
        }
    }

    private renderChart() {

        if (!this.data) return;

        const canvas = this.el.nativeElement.querySelector('canvas') as HTMLCanvasElement | null;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        this.chart?.destroy();

        const customOptions = (this.data as any).options;
        const baseOptions: any = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top' as const,
                }
            }
        };
        const options = customOptions
            ? { responsive: true, maintainAspectRatio: false, ...customOptions }
            : baseOptions;

        this.chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.data.labels,
                datasets: this.data.datasets
            },
            options
        });
    }
}

export default ComponentGraphLineComponent;